/**
 * Sticky content column. Replaces WP Sticky Sidebar / Theia.
 *
 * The column is `.content-wrapper > .sidebar`. It sticks only at
 * min-width 992px, with 140px top gap (plus the admin bar). The column
 * keeps its own height so the widget background is not stretched.
 * A column taller than the viewport follows the scroll, then pins its
 * bottom; scrolling up pins the top again. Below 992px inline styles
 * are cleared and the theme drawer takes over.
 *
 * `position: sticky` cannot be used: `.body-container` is overflow hidden.
 */
(function () {
    'use strict';

    const MIN_WIDTH = 992;
    const TOP_GAP = 140;
    const sidebar = document.querySelector('.content-wrapper > .sidebar');

    if (!sidebar) {
        return;
    }

    const media = window.matchMedia('(min-width: ' + MIN_WIDTH + 'px)');
    const inner = document.createElement('div');
    inner.className = 'techkorm-sticky-sidebar';

    while (sidebar.firstChild) {
        inner.appendChild(sidebar.firstChild);
    }

    sidebar.appendChild(inner);

    let lastScrollY = window.scrollY;
    let viewportTop = TOP_GAP;
    let pinned = false;
    let frame = 0;

    const topGap = () => {
        if (!document.body.classList.contains('admin-bar')) {
            return TOP_GAP;
        }

        const bar = document.getElementById('wpadminbar');

        return TOP_GAP + (bar ? bar.offsetHeight : 32);
    };

    const release = () => {
        pinned = false;
        sidebar.style.height = '';
        inner.style.position = '';
        inner.style.top = '';
        inner.style.left = '';
        inner.style.width = '';
        inner.style.boxSizing = '';
    };

    const pin = (top) => {
        const rect = sidebar.getBoundingClientRect();
        const height = inner.offsetHeight;

        sidebar.style.height = height + 'px';
        inner.style.position = 'fixed';
        inner.style.top = top + 'px';
        inner.style.left = rect.left + 'px';
        inner.style.width = rect.width + 'px';
        inner.style.boxSizing = 'border-box';
        pinned = true;
    };

    const update = () => {
        if (!media.matches) {
            release();
            lastScrollY = window.scrollY;
            viewportTop = topGap();
            return;
        }

        const gap = topGap();
        const scrollY = window.scrollY;
        const delta = scrollY - lastScrollY;
        const height = inner.offsetHeight;
        const view = window.innerHeight;
        const parentRect = sidebar.parentElement.getBoundingClientRect();
        const sidebarTop = sidebar.getBoundingClientRect().top;

        lastScrollY = scrollY;

        if (sidebarTop >= gap) {
            release();
            viewportTop = gap;
            return;
        }

        if (height + gap <= view) {
            viewportTop = gap;
        } else if (!pinned) {
            viewportTop = Math.min(gap, Math.max(view - height, sidebarTop));
        } else {
            viewportTop -= delta;
            viewportTop = Math.min(gap, Math.max(view - height, viewportTop));
        }

        const parentLimit = parentRect.bottom - height;
        if (viewportTop > parentLimit) {
            viewportTop = parentLimit;
        }

        pin(viewportTop);
    };

    const requestUpdate = () => {
        if (frame) {
            return;
        }

        frame = window.requestAnimationFrame(() => {
            frame = 0;
            update();
        });
    };

    media.addEventListener('change', requestUpdate);
    window.addEventListener('scroll', requestUpdate, {passive: true});
    window.addEventListener('resize', requestUpdate);
    update();
}());
